<app-custom-select [iconClass]="'text-indent-left fw-bold'" [options]="transportersList" [(ngModel)]="localValue"
  [title]="title" (ngModelChange)="onValueChange($event)" [isDisabled]="isDisabled" [createNewText]="'Add New Transporter'"
  (onClickCreateNew)="createNewTransporter()"></app-custom-select>
